<template>
  <div
    class="calico-business-card"
    v-bind="$attrs"
    @click="selectCard"
  >
    <div
      class="container"
      :class="{ active: isActive, disabled }"
    >
      <div
        v-if="image != undefined"
        class="image-container"
      >
        <img
          v-if="image"
          :src="image"
          alt="Business Image"
          class="business-image"
        >
        <div
          v-else
          class="no-image-container"
        >
          <i class="bi bi-shop" />
        </div>
      </div>
      <div
        class="content"
        :class="{ disabled }"
      >
        <label
          v-if="nonOperating"
          class="label--xsmall operative-flag"
        >{{ nonOperatingText.toUpperCase() }}</label>

        <!-- <div v-if="statusBadge" :class="['status-badge', statusBadgeColor]">
          <span class="label--xsmall">{{ statusBadge }}</span>
        </div> -->
        <h3 class="body--large">
          {{ title }}
        </h3>
        <p class="body--xsmall">
          {{ address }}
        </p>
        <p class="body--xsmall">
          {{ city }}, {{ state }} {{ zip }}
        </p>
        <p class="body--xsmall">
          {{ phoneNumber }}
        </p>
        <p class="body--xsmall">
          {{ description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "CalicoBusinessCard",

  props: {
    value: {
      type: [String, Number, Object],
      required: true,
    },
    modelValue: {
      type: [String, Number, Object],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    city: {
      type: String,
      default: "",
    },
    state: {
      type: String,
      default: "",
    },
    address: {
      type: String,
      default: "",
    },
    zip: {
      type: String,
      default: "",
    },
    phoneNumber: {
      type: String,
      default: "",
    },
    nonOperating: {
      type: Boolean,
      default: false,
    },
    nonOperatingText: {
      type: String,
      default: '',
    },
    image: {
      type: String
    },
    statusBadge: {
      type: String,
      default: ""
    },
  },
  computed: {
    statusBadgeColor() {
      const colorMap = {
        "Betascore Available": 'badge-green-outline',
        "No Betascore": 'badge-black-outline',
      }
      return colorMap[this.statusBadge]
    },
    isActive() {
      return this.value === this.modelValue;
    },
  },
  methods: {
    selectCard() {
      if (!this.disabled && this.value !== this.modelValue) {
        this.$emit("update:modelValue", this.value);
      }
    },
  },
};
</script>

<style lang="scss">
.calico-business-card {
  height: fit-content;
  width: 100%;
  @media (min-width: 731px) {
    width: 100%;
    max-width: $tablet-breakpoint-min-width;
  }

  .container {
    @include inset-space($space-medium);
    border: 1px solid $color-neutral-light;
    border-radius: $radius-large;
    color: $color-black;
    cursor: pointer;
    @include stack-space($space-none);
    background: $color-white;

    &:hover:not(.disabled) {
      background-color: $color-neutral-lightest;
      border-color: $color-neutral-light;
    }

    .image-container {
      overflow: hidden;
      border-radius: $radius-large $radius-large 0 0;

      .business-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .no-image-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        background: $color-neutral-light;

        .bi-shop {
          font-size: $icon-large;
          color: $color-white;
        }
      }
    }

    .content {
      @include stack-space($space-none);
      padding: $space-medium;

      div {
        @include inset-space($space-none);
        width: fit-content;
        height: 16px;
        padding: $space-xxsmall $space-xsmall $space-xxsmall $space-xsmall;
      }
      h3,
      p {
        margin: 0;
      }

      .operative-flag {
        color: $color-red-dark;
        font-weight: $font-weight-bold;
      }
    }
  }

  .active {
    background-color: $color-lapis-lightest;
    border-color: $color-neutral-light;
  }

  .disabled {
    background-color: $color-neutral-light;
    border-radius: $radius-large;
    border-color: $color-neutral-light;
    color: $color-neutral-dark;
    cursor: not-allowed;
  }

  @media (max-width: $tablet-breakpoint-min-width) {
    .container {
      width: 100%;
      border-radius: $radius-large;
      padding: 0;

      .image-container {
        height: 107px;
      }

      .content {
        text-align: start;
        padding: $space-medium;
      }
    }
  }

  @media (min-width: #{$mobile-breakpoint-min-width + 1}) {
    .container {
      flex-direction: row;
      align-items: center;
      padding: 0;

      .image-container {
        width: 20%;
        height: 150px;
        border-radius: $radius-large 0 0 $radius-large;
      }

      .content {
        flex: 1;
        padding: $space-large;
      }
    }
  }
}
</style>